import { createSelector } from 'reselect'


export const getAllSites = state => state.sites.list
export const getCurrentSiteId = state => state.sites.currentSite
export const getSiteByKey = (state, siteId) => getAllSites(state).find(site => site.key === siteId)

export const getCurrentSite = createSelector(
  getAllSites,
  getCurrentSiteId,
  (sites, siteId) => {
    return sites.find(site => site.key === siteId)
  },
)


export const getApiKeys = createSelector(
  getCurrentSite,
  site => site.apiKeys
)



// WEBPACK FOOTER //
// ./src/modules/sites/selectors.js